<template>
<div class="container-fluid p-2">
  <div class="card">
    <div class="card-body position-relative">
      <button class="back-btn" @click="$emit('back')">&#8592; Back</button>
      <div class="form-title">Apply for a Taxi1 driver prepaid card</div>
      <div class="form-desc text-hint">
        Prefer to pick up your card in person at the driver office?        
        <br />
        Just drop by — no need to submit this form.
      </div>
      <div class="form-desc">
        Please fill out the details below, note that name and date of birth need to match your official document.
      </div>
      <form class="card-form" @submit="handleSubmit">
        <div class="form-row">
          <div class="form-group">
            <label>Name</label>
            <div class="form-inline">
              <input type="text" class="form-control" placeholder="First name" v-model="formData.first_name" :class="{ 'is-invalid': errors.first_name }" />
              <div v-if="errors.first_name" class="error-message">{{ errors.first_name }}</div>
              <input type="text" class="form-control" placeholder="Middle name" v-model="formData.middle_name" :class="{ 'is-invalid': errors.middle_name }" />
              <div v-if="errors.middle_name" class="error-message">{{ errors.middle_name }}</div>
              <input type="text" class="form-control" placeholder="Last name" v-model="formData.last_name" :class="{ 'is-invalid': errors.last_name }" />
              <div v-if="errors.last_name" class="error-message">{{ errors.last_name }}</div>
            </div>
            <div class="form-row">

            </div>
            <div class="form-group">
                <label>Date of birth</label>
                <Datepicker1 
                  class="datepicker-here form-control" 
                  v-model="formData.birthday" 
                  :format="'dd/MM/yyyy'" 
                  :enable-time-picker="false" 
                  data-language="en" 
                  placeholder="Select date of birth" 
                  :class="{ 'is-invalid': errors.birthday }"
                />
                <div v-if="errors.birthday" class="error-message">{{ errors.birthday }}</div>
            </div>
          </div>
          <div class="form-group">
            <label>Address</label>
            <input type="text" class="form-control" placeholder="Address line 1" v-model="formData.address_line_1" :class="{ 'is-invalid': errors.address_line_1 }" />
            <div v-if="errors.address_line_1" class="error-message">{{ errors.address_line_1 }}</div>
            <input type="text" class="form-control" placeholder="Address line 2" v-model="formData.address_line_2"  />
            <!-- <div v-if="errors.address_line_2" class="error-message">{{ errors.address_line_2 }}</div> -->
            <div class="d-flex justify-content-between gap-2">
              <input type="text" class="form-control" placeholder="Suburb" v-model="formData.suburb" :class="{ 'is-invalid': errors.suburb }" />
              <input type="text" class="form-control" placeholder="Postcode" v-model="formData.postcode" :class="{ 'is-invalid': errors.postcode }" />
            </div>
            <div v-if="errors.suburb" class="error-message">{{ errors.suburb }}</div>
            <div v-if="errors.postcode" class="error-message">{{ errors.postcode }}</div>
            <div class="d-flex justify-content-between gap-2">
              <select class="form-control" v-model="formData.state" :class="{ 'is-invalid': errors.state }">
                                <option value="" disabled selected>State</option>
                                <option value="NSW">NSW</option>
                                <option value="VIC">VIC</option>
                                <option value="QLD">QLD</option>
                                <option value="SA">SA</option>
                                <option value="WA">WA</option>
                                <option value="NT">NT</option>
                                <option value="TAS">TAS</option>
                                <option value="ACT">ACT</option>
              </select>
              <input type="text" class="form-control" value="Country: Australia" readonly style="font-weight:bold;" />
            </div>
            <div v-if="errors.state" class="error-message">{{ errors.state }}</div>
          </div>
        </div>         
        <div class="form-note">
          Note: the card incurs a $5 monthly fee. For detailed fees and charges, <a href="#">click here</a>.<br>
          For terms and conditions of the taxi1 driver prepaid card, <a href="#">click here</a>.<br>
          (External Links)
        </div>
        <button class="btn btn-green submit-btn" type="submit" :disabled="isSubmitting">
          {{ isSubmitting ? 'Submitting...' : 'Submit Application' }}
        </button>
      </form>
    </div>
  </div>
</div>
</template>

<script setup>
import { ref } from 'vue'
import { useCardStore } from '@/store/driver/card'
import Datepicker1 from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'


const emit = defineEmits(['back', 'success'])
const cardStore = useCardStore()
const driver = JSON.parse(localStorage.getItem('Driver') || '{}');
// 處理生日：將字串格式的日期 (YYYY-MM-DD) 轉換為 Date 物件
let birthdayValue = null;
if (driver.birthday) {
  if (typeof driver.birthday === 'string') {
    const dateParts = driver.birthday.split('-');
    if (dateParts.length === 3) {
      birthdayValue = new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]));
    } else {
      birthdayValue = new Date(driver.birthday);
    }
  } else if (driver.birthday instanceof Date) {
    birthdayValue = driver.birthday;
  }
}
const formData = ref({
  first_name: driver.first_name || '',
  middle_name: driver.middle_name || '',
  last_name: driver.last_name || '',
  birthday: birthdayValue,
  address_line_1: driver.address || '',
  address_line_2: '',
  suburb: driver.suburb || '',
  postcode: driver.post_code || '',
  state: driver.state || '',
  country: 'AU',
})

const errors = ref({
  first_name: '',
  middle_name: '',
  last_name: '',
  birthday: '',
  address_line_1: '',
  address_line_2: '',
  suburb: '',
  postcode: '',
  state: '',
})

const validateForm = () => {
  // 重置錯誤訊息
  errors.value = {
    first_name: '',
    middle_name: '',
    last_name: '',
    birthday: '',
    address_line_1: '',
    address_line_2: '',
    suburb: '',
    postcode: '',
    state: '',
  }
  
  let isValid = true
  
  if (!formData.value.first_name) {
    errors.value.first_name = 'First name is required'
    isValid = false
  }
  if (!formData.value.last_name) {
    errors.value.last_name = 'Last name is required'
    isValid = false
  }
  if (!formData.value.birthday) {
    errors.value.birthday = 'Date of birth is required'
    isValid = false
  }
  if (!formData.value.address_line_1) {
    errors.value.address_line_1 = 'Address line 1 is required'
    isValid = false
  }
  // if (!formData.value.address_line_2) {
  //   errors.value.address_line_2 = 'Address line 2 is required'
  //   isValid = false
  // }
  if (!formData.value.suburb) {
    errors.value.suburb = 'Suburb is required'
    isValid = false
  }
  if (!formData.value.postcode) {
    errors.value.postcode = 'Postcode is required'
    isValid = false
  }
  if (!formData.value.state) {
    errors.value.state = 'State is required'
    isValid = false
  }
  
  return isValid
}


const isSubmitting = ref(false)


async function handleSubmit(e) {
  e.preventDefault()
  
  if (!validateForm()) {
    return
  }
  
  isSubmitting.value = true
  
  try {
   
    const submitData = { ...formData.value }
    if (submitData.birthday) {
      const date = new Date(submitData.birthday)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      submitData.date_of_birth = `${year}-${month}-${day}`
    }
    
    delete submitData.birthday
    
    // 串接 API
    await cardStore.applyNewCard(submitData)
    
    // 成功時導向成功頁面
    emit('success')
    
  } catch (error) {
    console.error('Card application error:', error)
    
    // 處理錯誤訊息
    let errorMessage = 'Application failed, please try again later'
    
    if (error.response?.data?.message) {
      errorMessage = error.response.data.message
    } else if (error.message) {
      errorMessage = error.message
    }
    
    // 使用 SweetAlert 顯示錯誤訊息
    // Swal.fire({
    //   icon: 'error',
    //   title: errorMessage,
    //   confirmButtonText: 'OK'
    // })
    
  } finally {
    isSubmitting.value = false
  }
}
</script>

<style scoped>
.back-btn {
  position: absolute;
  top: 18px;
  right: 24px;
  background: #00c962;
  border: 1px solid #dbe2ea;
  border-radius: 20px;
  padding: 6px 18px;
  font-size: 1rem;
  color: #12223b;
  cursor: pointer;
  z-index: 2;
  transition: background 0.2s;
}
.back-btn:hover {
  background: #00c962;
  color: #fff;
}
.form-title {
    width: 1140px;
    height: 30px;

    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 30px;

    color: #051C2C;
}
.text-hint {
  color: #ff4040 !important;
}

.form-desc {
    margin-top: 30px;
    margin-bottom: 30px;
    width: 560px;
    height: 46px;
    /* Portal/Portal – normal */
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 23px;

    color: #051C2C;
}
.card-form {
  margin-top: 12px;
}
.form-row {
  display: flex;
  gap: 32px;
  margin-bottom: 13px;
}
.form-group {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 23px;
    color: #051C2C;
}

.form-inline {
  display: flex;
  gap: 12px;
}
.form-control {
  border-radius: 8px;
  border: 1px solid #dbe2ea;
  padding: 10px 16px;
  font-size: 1rem;
  margin-bottom: 8px;
  height: 48px;
  line-height: 1.5;
  display: flex;
  align-items: center;
}

/* 日期選擇器樣式調整 */
.datepicker-here {
  height: 48px !important;
  line-height: 1.5 !important;
  display: flex !important;
  align-items: center !important;
}

/* 確保日期選擇器內部元素對齊 */
.datepicker-here .dp__input {
  height: 48px !important;
  line-height: 1.5 !important;
  padding: 10px 16px !important;
  border: none !important;
  background: transparent !important;
  font-size: 1rem !important;
}
.form-control[readonly] {
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 23px;
    color: #051C2C;
}
.form-note {
  font-size: 0.95rem;
  margin: 18px 0 24px 0;
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 19px;
  color: #5E707D;
}
.form-note a {
  color: #12223b;
  text-decoration: underline;
}
.btn-green.submit-btn {
  background: #00c962;
  color: #051C2C;
  border-radius: 24px;
  padding: 10px 32px;
  font-size: 1rem;
  font-weight: 500;
  border: none;
  cursor: pointer;
}

.btn-green.submit-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.error-message {
  color: #ff4040;
  font-size: 0.875rem;
  margin-top: 4px;
  margin-bottom: 8px;
}

.is-invalid {
  border-color: #ff4040 !important;
}
</style> 